import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_URL_STARMETER_CRAWLER;
const TOKEN =
  "hTIs76A64ZLWAA9j3lIEpt6qiYD3v2UXJBHd07xCMmq7XQaiSCT9U6AEP0i36AVk";

export async function fetchStarmeterExtractor(filters = {}) {
  const response = await axios.get(`${BACKEND_URL}/list-starmeter-crawler`, {
    params: filters,
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  });
  return response.data;
}

export async function fetchCrawlerStatus() {
  const response = await axios.get(`${BACKEND_URL}/crawler-status`, {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  });
  return response.data;
}

export async function runStarmeterCrawler(body = {}) {
  const response = await axios.post(`${BACKEND_URL}/run-crawler`, body, {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  });
  return response.data;
}
